import React from 'react';
import { Badge } from '@mantine/core';

const ProBadge = ({ size = 'md', ...props }) => {
  return (
    <Badge
      size={size}
      variant="gradient"
      gradient={{ from: 'yellow', to: 'orange', deg: 45 }}
      style={{ 
        boxShadow: '0 2px 8px rgba(255,152,0,0.3)',
        cursor: 'default'
      }}
      {...props}
    >
      ⭐ PRO
    </Badge>
  );
};

export default ProBadge;
